export default function AboutServices(){
    return(
        <div>
        <h1 style={{fontSize:"48px", color:"#486A6F"}}>Oops! Page Still Under Construction</h1>
        </div>
    )
}